export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-archive-efbfe624d15a9f4af15419cffdf645c1.svg";